"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.legacySalvoLiteLog = exports.registerLegacySalvoLiteComponent = exports.LEGACY_COMPONENT_REGISTRATION = exports.LegacySalvoLiteComponent = void 0;
var componentService_1 = require("../componentService");
var dummyTheme = {
    getComponents: function () {
        return [];
    },
    getComponentById: function () {
        return [];
    },
    getComponentsByType: function (componentConst, includeSubclasses) {
        if (includeSubclasses === void 0) { includeSubclasses = true; }
        return [];
    },
};
var LegacySalvoLiteComponent = /** @class */ (function () {
    function LegacySalvoLiteComponent(component) {
        this.instance = null;
        this.el = null;
        this.component = component;
    }
    LegacySalvoLiteComponent.prototype.init = function (el) {
        this.el = el;
        this.instance = new this.component(dummyTheme, this.el);
        if (this.instance.onInit) {
            this.instance.onInit();
        }
    };
    return LegacySalvoLiteComponent;
}());
exports.LegacySalvoLiteComponent = LegacySalvoLiteComponent;
var i = 0;
exports.LEGACY_COMPONENT_REGISTRATION = Symbol('LegacyComponentRegistration');
function registerLegacySalvoLiteComponent(_a) {
    var component = _a.component, selector = _a.selector;
    componentService_1.componentService.register({
        name: component.name || "LegacySalvoLiteComponent".concat(i++),
        component: LegacySalvoLiteComponent.bind(undefined, component),
        meta: {
            selector: selector,
            isLegacy: true,
        },
        props: [],
        refs: [],
    });
    return exports.LEGACY_COMPONENT_REGISTRATION;
}
exports.registerLegacySalvoLiteComponent = registerLegacySalvoLiteComponent;
var logging_1 = require("../../utils/logging");
exports.legacySalvoLiteLog = new logging_1.DefaultLog();
exports.legacySalvoLiteLog.setLogPrefix('Theme-LegacySalvoLiteComponent');
exports.legacySalvoLiteLog.setLogLevel(logging_1.LogLevel.WARN);
//# sourceMappingURL=LegacySalvoLiteComponent.js.map